import { isFetchClientError } from "@shared/apis/fetch-clients/fetch-client-error";

type NestErrorBody = { message?: string | string[] };

const isNestErrorBody = (data: unknown): data is NestErrorBody =>
  typeof data === "object" && data !== null && "message" in data;

export const getFetchClientErrorMessage = (
  error: unknown,
  fallback: string,
): string => {
  if (!isFetchClientError(error) || error.status >= 500) return fallback;
  if (!isNestErrorBody(error.data)) return fallback;

  const { message } = error.data;
  if (typeof message === "string") return message;
  if (Array.isArray(message) && typeof message[0] === "string") {
    return message[0];
  }
  return fallback;
};
